import React, { FC, memo } from 'react'
import { useParams } from 'react-router-dom'
import {
	ArticleViewComponent,
	BreadCrumbsArticleViewComponent,
	KindTypeModel,
	VideoViewComponent,
	articleSlice,
	articleSelector,
} from 'Pages/knowledge'
import { useAppDispatch } from 'Src/hooks'
import { useSelector } from 'react-redux'
import { useEffectOnce } from 'Src/hooks/useEffectOnce'

interface RouteParams {
	slugProject: string
	slugArticle: string
}

const ArticleView: FC = () => {
	const { viewArticle, clearArticle } = useAppDispatch({
		viewArticle: articleSlice.actions.viewArticle,
		clearArticle: articleSlice.actions.clearArticle,
	})
	const article = useSelector(articleSelector.getArticle)
	const { slugArticle, slugProject } = useParams<RouteParams>()

	useEffectOnce(() => {
		viewArticle({ project: slugProject, article: slugArticle })
		return () => {
			clearArticle()
		}
	})

	return (
		article && (
			<div>
				<BreadCrumbsArticleViewComponent article={article} />
				{article.kind === KindTypeModel.VIDEO ? (
					<VideoViewComponent video={article} />
				) : (
					<ArticleViewComponent article={article} />
				)}
			</div>
		)
	)
}
const ArticleViewContainer = memo(ArticleView)
export default ArticleViewContainer
